<template>
  <div>
    <div>
      <el-table :data="PositionData" border :height="260" style="width: 100%;" highlight-current-row v-if="isLoad">
        <!-- <el-table-column prop="exchange" label="交易所"> </el-table-column>
        <el-table-column prop="underlying" label="标的代码"> </el-table-column>
        <el-table-column prop="subAccountNo" label="子账业务" :formatter="changeSubNo"> </el-table-column>
        <el-table-column prop="buyContractVolume" label="当前买持仓量(手)"> </el-table-column>
        <el-table-column prop="buyTodayOpenVolume" label="今日开仓数量(买)"> </el-table-column>
        <el-table-column prop="buyTodayCloseVolume" label="今日平仓数量(买)"> </el-table-column>
          
        <el-table-column prop="buyAveragePrice" label="持仓均价(买)(手)"> 
          <template slot-scope="scope">
            <span> {{Number(scope.row.buyAveragePrice).toFixed(2)}} </span>
          </template>
        </el-table-column>
        <el-table-column prop="sellContractVolume" label="当前卖持仓量(手)"> </el-table-column>
        <el-table-column label="净头寸持仓(手)"  :formatter="net"> </el-table-column>
        <el-table-column prop="sellTodayOpenVolume" label="今日开仓数量(卖)"> </el-table-column>
        <el-table-column prop="sellTodayCloseVolume" label="今日平仓数量(卖)"> </el-table-column>
           
        <el-table-column prop="sellAveragePrice" label="持仓均价(卖)(手)"> 
          <template slot-scope="scope">
            <span> {{Number(scope.row.sellAveragePrice).toFixed(2)}} </span>
          </template>
        </el-table-column>
        <el-table-column label="持仓盈亏(浮)" :formatter="float"> </el-table-column>
        <el-table-column label="持仓盈亏(盯)" :formatter="floatF"> </el-table-column>
        <el-table-column label="平仓盈亏(逐笔)" :formatter="closeOutLossZ"> </el-table-column>
        <el-table-column label="平仓盈亏(盯)" :formatter="closeOutLoss"> </el-table-column>
        <el-table-column prop="buyOriginalPriceContractValue" label="持仓成本(买)"> </el-table-column>
        <el-table-column prop="sellOriginalPriceContractValue" label="持仓成本(卖)"> </el-table-column> -->
        <!-- <el-table-column label="成交金额(买)" :formatter="buyMab"> </el-table-column>   
        <el-table-column label="成交金额(卖)" :formatter="sellMab"> </el-table-column>  
        <el-table-column label="净头持仓成本"  :formatter="cost"> </el-table-column> -->

        <el-table-column v-for="item in showFields" :key="item.value" :prop="item.value" :label="item.key" show-overflow-tooltip> </el-table-column>
        <el-table-column label="操作" v-if="!dis" width="90"> 
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="oneCloseOut(scope.row)" :disabled="closeDis(scope.row)"> 平仓 </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="!dis" width="90"> 
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="closeOut(scope.row)" :disabled="closeDis(scope.row)"> 一键平仓 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :close-on-click-modal="false" title="一键平仓" :visible.sync="dialogVisible" width="1350px" :before-close="handleClose" v-dialogDrag>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>交易所</span>
            </el-col>
            <el-col :span="16">
              <span> {{close.exchange}} </span>
            </el-col>
          </el-col>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>标的代码</span>
            </el-col>
            <el-col :span="16">
              <span> {{close.underlying}} </span>
            </el-col>
          </el-col>
        </el-row>
        <p class="close_hint">如为单边持仓的话只填一项即可,如为多边持仓,买平和卖平的信息都要填写.数量为0则代表该单边不进行平仓操作.左边为平买持,右边为平卖持.如果为原油交易中心或上期所默认为平历史单,如需平今操作请自行切换</p>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>买卖方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.buy.buySell" sise="small" disabled>
                <el-option v-for="item in buySellOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>买卖方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.sell.buySell" sise="small" disabled>
                <el-option v-for="item in buySellOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>场内开平方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.buy.offsetFlag" sise="small" @change="BuyChangeOffsetFlag">
                <el-option v-for="item in offsetFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>场内开平方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.sell.offsetFlag" sise="small" @change="SellChangeOffsetFlag">
                <el-option v-for="item in offsetFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>投机套保标识</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.buy.hedgeFlag" sise="small">
                <el-option v-for="item in hedgeFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>投机套保标识</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="close.sell.hedgeFlag" sise="small">
                <el-option v-for="item in hedgeFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>平仓数量</span>
            </el-col>
            <el-col :span="16" style="position:reletive;">
              <el-input-number v-model="close.buy.orderVolume" controls-position="right" size="small" :min="0"></el-input-number>
              <!-- <el-input-number v-model="close.buy.orderVolume" controls-position="right" size="small" :min="0" :max="close.buy.copyNum"></el-input-number> -->
              <p style="display:inline-block;margin-left: 10px;color:red; position: absolute;"> {{ isShow(close.buy.copyNum, close.buy.offsetFlag, close.exchange)}} </p>
            </el-col>
          </el-col>
          <p></p>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>平仓数量</span>
            </el-col>
            <el-col :span="16" style="position:reletive;">
              <el-input-number v-model="close.sell.orderVolume" controls-position="right" size="small" :min="0"></el-input-number>
              <!-- <el-input-number v-model="close.sell.orderVolume" controls-position="right" size="small" :min="0" :max="close.sell.copyNum"></el-input-number> -->
              <p style="display:inline-block;margin-left: 10px;color:red; position: absolute;"> {{ isShow(close.sell.copyNum, close.sell.offsetFlag, close.exchange)}} </p>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="8">
              <span>平仓价</span>
            </el-col>
            <el-col :span="16">
              <el-input-number v-model="close.buy.orderPrice" controls-position="right" size="small"></el-input-number>
            </el-col>
          </el-col>
          <el-col :span="12" style="padding-left: 50px;">
            <el-col :span="8">
              <span>平仓价</span>
            </el-col>
            <el-col :span="16">
              <el-input-number v-model="close.sell.orderPrice" controls-position="right" size="small"></el-input-number>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-col :span="8">
              <span>平仓描述</span>
            </el-col>
            <el-col :span="16">
              <el-input v-model="close.description" placegolder="请输入平仓描述" size="small"></el-input>
            </el-col>
          </el-col>
        </el-row>
        <div class="cut-off"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="allCloseOut">一键平仓</el-button>
        </span>
      </el-dialog>

      <el-dialog :close-on-click-modal="false" title="单边平仓" :visible.sync="dialogUnilateral" width="500px" :before-close="oneHandleClose" v-dialogDrag>
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>交易所</span>
            </el-col>
            <el-col :span="16">
              <span> {{oneClose.exchange}} </span>
            </el-col>
          </el-col>
          <el-col :span="24" style="margin-top: 15px;">
            <el-col :span="8">
              <span>标的代码</span>
            </el-col>
            <el-col :span="16">
              <span> {{oneClose.underlying}} </span>
            </el-col>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>买卖方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="oneClose.buySell" sise="small" disabled>
                <el-option v-for="item in buySellOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>场内开平方向</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="oneClose.offsetFlag" sise="small" @change="BuyChangeOffsetFlag">
                <el-option v-for="item in offsetFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>投机套保标识</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="oneClose.hedgeFlag" sise="small">
                <el-option v-for="item in hedgeFlagOptions" :value="item.value" :label="item.label" :key="item.value"></el-option>
              </el-select>
            </el-col>
          </el-col>
        </el-row>
        <p style="margin: 10px 0;">
          <span v-if="row.exchange != 'SHFE' && row.exchange != 'INE'">
            其中买持可平 {{row.buyHistoryDayRemainCloseVolume + row.buyTodayDayRemainCloseVolume}} 手, 卖持可平 {{row.sellHistoryDayRemainCloseVolume + row.sellTodayDayRemainCloseVolume}}手;
          </span>
          <span v-if="row.exchange == 'SHFE' || row.exchange == 'INE'">
            其中买持今仓可平{{row.buyTodayDayRemainCloseVolume}}手, 历史仓可平{{row.buyHistoryDayRemainCloseVolume}}手; 卖持今仓可平 {{row.sellTodayDayRemainCloseVolume}}手, 历史仓可平{{row.sellHistoryDayRemainCloseVolume}}手;
          </span>
        </p>
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>平仓数量</span>
            </el-col>
            <el-col :span="16" style="position:reletive;">
              <el-input-number v-model="oneClose.orderVolume" controls-position="right" size="small" :min="0"></el-input-number>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>平仓价</span>
            </el-col>
            <el-col :span="16">
              <el-input-number v-model="oneClose.orderPrice" controls-position="right" size="small"></el-input-number>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-col :span="8">
              <span>平仓描述</span>
            </el-col>
            <el-col :span="16">
              <el-input v-model="oneClose.description" placegolder="请输入平仓描述" size="small"></el-input>
            </el-col>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="buyOrder">买平</el-button>
          <el-button type="primary" @click="sellOrder">卖平</el-button>
        </span>
      </el-dialog>

      <el-dialog title="改变显示字段" :visible.sync="dialogShowFields" :before-close="beforeClose">
        <el-transfer v-model="showValue" :data="allFields" @left-check-change="leftChange" @right-check-change="rightChange" target-order="push" :titles="['所有字段', '需显示字段']"></el-transfer>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" @click="enter">设置</el-button>
          <el-button type="primary" size="mini" @click="beforeClose">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios'
  import g from '@/components/Global.vue'
  import bus from '@/assets/eventBus'
  export default {
    name: 'for_allCC',
    data() {
      return {
        sub: '',
        id: '',
        user: '',
        PositionData: [],
        precision: 0,
        dialogVisible: false,
        dialogUnilateral: false,
        closeData: {},
        dis: false, //用于表示是否是输入交易密码进入的
        // socketData: [],

        close: {    //用于一键平仓
          exchange: '',
          underlying: '',
          subAccountNo: '',
          clientId: '',
          clientBindId: '',
          description: '',
          buy: {
            buySell: '',
            orderPrice: '',
            orderVolume: '',
            copuNum: 0,
            offsetFlag: '',
            hedgeFlag: '',
          },
          sell: {
            buySell: '',
            orderPrice: '',
            orderVolume: '',
            copuNum: 0,
            offsetFlag: '',
            hedgeFlag: '',
          },
        },  
        oneClose: {
          exchange: '',
          underlying: '',
          subAccountNo: '',
          clientId: '',
          clientBindId: '',
          description: '',
          buySell: '',
          orderPrice: '',
          orderVolume: '',
          copuNum: 0,
          offsetFlag: '',
          hedgeFlag: '',
        },
        row: {},

        offsetFlagOptions: [{
            value: 1,
            label: "平仓"
          },
          {
            value: 3,
            label: "平今"
          },
        ],
        hedgeFlagOptions: [{
            value: 1,
            label: "投机"
          },
          {
            value: 2,
            label: "套利"
          },
          {
            value: 3,
            label: "套保"
          },
          {
            value: 4,
            label: "备兑"
          }
        ],
        buySellOptions: [
          {
            value: 'B',
            label: '买'
          },
          {
            value: 'S',
            label: '卖'
          }
        ],

        // 切换显示的字段
        dialogShowFields: false,
        showValue: [],    //穿梭框显示的字段集合
        allFields: [    //穿梭框全部字段集合
          {value: 'exchange', key: '交易所'},
          {value: 'underlying', key: '标的代码'},
          {value: 'subAccountName', key: '子账业务'},
          {value: 'buyContractVolume', key: '当前买持仓量(手)'},
          {value: 'buyTodayOpenVolume', key: '今日开仓数量(买)'},
          {value: 'buyTodayCloseVolume', key: '今日平仓数量(买)'},
          {value: 'buyAveragePriceValue', key: '持仓均价(买)(手)'},
          {value: 'sellContractVolume', key: '当前卖持仓量(手)'},
          {value: 'netValue', key: '净头寸持仓(手)'},
          {value: 'sellTodayOpenVolume', key: '今日开仓数量(卖)'},
          {value: 'sellTodayCloseVolume', key: '今日平仓数量(卖)'},
          {value: 'sellAveragePriceValue', key: '持仓均价(卖)(手)'},
          {value: 'floatValue', key: '持仓盈亏(浮)'},
          {value: 'floatFValue', key: '持仓盈亏(盯)'},
          {value: 'closeOutLossZValue', key: '平仓盈亏(逐笔)'},
          {value: 'closeOutLossValue', key: '平仓盈亏(盯)'},
          {value: 'buyOriginalPriceContractValue', key: '持仓成本(买)'},
          {value: 'sellOriginalPriceContractValue', key: '持仓成本(卖)'},
        ],  
        showFields: [],
        isLoad: true,

        // 页码
        page: 1,
        total: 100,
        pageSize: 100,
      }
    },
    created() {
      bus.$on("daochuCCAll", this.daochu)
      bus.$on("compileAllCC", this.openDialog)
      bus.$on("reload", this.reload)    //定时刷新
      bus.$on("retryAllClose", this.retryAllClose)
      bus.$on("retryOneClose", this.retryOneClose)
      // bus.$on("socketArray", this.getSocketArray)
      bus.$on("allCCs", this.allCCs)
      this.showFields = this.allFields
    },
    destroyed() {
      bus.$off("reload", this.reload)
      this.PositionData = []
    },
    methods: {
      allCCs(data) {
        this.PositionData = data
      },
      //委托单分页
      PositionChange(val) {
        axios.post('client/forward/forwardcontract/queryTotals.do', this.qs.stringify({
          clientBindId: this.id,
          expirStatus: 0,
          'subAccountNos[]': this.sub,
        })).then(data => {
          if (data.data.success) {
            let positionProfit = 0
            let closeProfit = 0
            let float = 0
            this.PositionData = data.data.fcts
            this.PositionData.forEach(item => {
              this.$set(item, 'subAccountName', this.changeSubNo(item))
              this.$set(item, 'buyAveragePriceValue', this.round(item.buyAveragePrice))
              this.$set(item, 'netValue', this.net(item))
              this.$set(item, 'sellAveragePriceValue', this.round(item.sellAveragePrice))
              this.$set(item, 'floatValue', this.float(item))
              this.$set(item, 'floatFValue', this.floatF(item))
              this.$set(item, 'closeOutLossZValue', this.closeOutLossZ(item))
              this.$set(item, 'closeOutLossValue', this.closeOutLoss(item))

              float += this.float(item)
              positionProfit += this.floatF(item)
              closeProfit += this.closeOutLoss(item)
            })
            let obj = {
              float,
              positionProfit,
              closeProfit
            }
            bus.$emit("topAllCC", obj)
          } else {
            this.PositionData = []
          }

        })
      },

      daochu() {
        // window.open(`${g.baseURL}client/forward/excel/exportForwardContractTotals.do?clientBindId=${this.id}&subAccountNos=${this.sub}`)
        this.postDown(`${g.baseURL}client/forward/excel/exportForwardContractTotals.do`, {
          'clientBindId': this.id,
          'subAccountNos[]': this.sub,
          'expirStatus': 0,
        })
      },
      closeOut(row) {
        this.row = row
        this.close.exchange = row.exchange
        this.close.underlying = row.underlying
        this.close.subAccountNo = row.subAccountNo
        this.close.clientId = this.user
        this.close.clientBindId = this.id

        this.close.buy.buySell = 'S'
        this.close.sell.buySell = 'B'
        // this.close.buy.orderVolume = row.buyContractVolume
        // this.close.sell.orderVolume = row.sellContractVolume
        // this.close.buy.copyNum = row.buyContractVolume
        // this.close.sell.copyNum = row.sellContractVolume
        this.close.buy.orderVolume = row.buyHistoryDayRemainCloseVolume + row.buyTodayDayRemainCloseVolume
        this.close.sell.orderVolume = row.sellHistoryDayRemainCloseVolume + row.sellTodayDayRemainCloseVolume
        this.close.buy.copyNum = row.buyHistoryDayRemainCloseVolume + row.buyTodayDayRemainCloseVolume
        this.close.sell.copyNum = row.sellHistoryDayRemainCloseVolume + row.sellTodayDayRemainCloseVolume

        this.close.buy.offsetFlag = 1
        this.close.sell.offsetFlag = 1
        this.close.buy.hedgeFlag = 1
        this.close.sell.hedgeFlag = 1

        let price = 0
         // 获取最新价
        this.socketData.forEach(item => {
          if(item.market == row.exchange && item.code == row.underlying && item.subAccountNo == row.subAccountNo) {
            price = Number(item.price)
          }
        })
        this.close.buy.orderPrice = price
        this.close.sell.orderPrice = price
        if(row.exchange == 'SHFE' || row.exchange == 'INE') { //上期所和原油中心存在平今操作,如没有历史仓则默认平今仓.有历史仓优先平历史仓
          this.close.buy.orderVolume = row.buyHistoryDayRemainCloseVolume
          this.close.sell.orderVolume = row.sellHistoryDayRemainCloseVolume
          this.close.buy.copyNum = row.buyHistoryDayRemainCloseVolume
          this.close.sell.copyNum = row.sellHistoryDayRemainCloseVolume
        }
        this.dialogVisible = true
      },
      oneCloseOut(row) {
        this.row = row
        this.oneClose.exchange = row.exchange
        this.oneClose.underlying = row.underlying
        this.oneClose.subAccountNo = row.subAccountNo
        this.oneClose.clientId = this.user
        this.oneClose.clientBindId = this.id

        // this.close.buy.orderVolume = row.buyContractVolume
        // this.close.sell.orderVolume = row.sellContractVolume
        // this.close.buy.copyNum = row.buyContractVolume
        // this.close.sell.copyNum = row.sellContractVolume
        
        this.oneClose.buyCopyNum = row.buyHistoryDayRemainCloseVolume + row.buyTodayDayRemainCloseVolume
        this.oneClose.sellCopyNum = row.sellHistoryDayRemainCloseVolume + row.sellTodayDayRemainCloseVolume
        this.oneClose.orderVolume = 0
        this.oneClose.offsetFlag = 1
        this.oneClose.hedgeFlag = 1

        let price = 0
         // 获取最新价
        this.socketData.forEach(item => {
          if(item.market == row.exchange && item.code == row.underlying && item.subAccountNo == row.subAccountNo) {
            price = Number(item.price)
          }
        })
        this.oneClose.orderPrice = price
        this.dialogUnilateral = true
      },
      buyOrder() {
        this.oneClose.buySell = 'B' 
        this.oneCloseOrder()
      },
      sellOrder() {
        this.oneClose.buySell = 'S'
        this.oneCloseOrder()
      },
      oneCloseOrder() {
        if(this.oneClose.orderPrice <= 0) {
          this.$message({
            type: 'error',
            message: '平仓价不能小于或等于0',
            showClose: true
          })
          return
        }
        if(this.oneClose.orderVolume <= 0) {
          this.$message({
            type: 'error',
            message: '平仓数量不能小于或等于0',
            showClose: true
          })
          return
        }
        let token = window.sessionStorage.getItem("token")
        let data = {
          exchange: this.oneClose.exchange,
          underlying: this.oneClose.underlying,
          subAccountNo: this.oneClose.subAccountNo,
          clientId: this.oneClose.clientId,
          clientBindId: this.oneClose.clientBindId,
          description: this.oneClose.description,
          buySell: this.oneClose.buySell,
          orderPrice: this.oneClose.orderPrice,
          orderVolume: this.oneClose.orderVolume,
          offsetFlag: this.oneClose.offsetFlag,
          hedgeFlag: this.oneClose.hedgeFlag,
          tradeToken: token
        }
        this.axios.post("client/forward/forwardorderlog/requestCloseBatch.do", this.qs.stringify(data)).then(result => {
          if(result == 'token' ) {
            this.closeData = this.oneClose
            let obj = {
              id: this.id,
              type: 'oneClose'
            }
            this.dialogUnilateral = false
            bus.$emit("checkPass", obj)
          }
          if(result.data.success) {
            window.sessionStorage.setItem('token', result.data.FORWARD_TRADE_TOKEN)
            this.$message({
              type:"success",
              message:"平仓请求发送成功",
              showClose: true
            })
            this.dialogUnilateral = false
            this.oneHandleClose()
            this.anewGet()
          }
        })
      },
      getSocketArray(arr){
        this.socketData = arr
      },
      reload(arr){
        // if(arr[0] == 'for_allCC' || arr[1] == 'for_allCC') {
        //   this.PositionChange()
        // }
        // this.PositionChange()
      },
      retryAllClose() {
        this.close = this.closeData
        this.allCloseOut()
      },
      retryOneClose() {
        this.oneClose = this.closeData
        this.oneCloseOrder()
      },
      allCloseOut() {
        let token = window.sessionStorage.getItem("token")
        let buyData = {
          exchange: this.close.exchange,
          underlying: this.close.underlying,
          subAccountNo: this.close.subAccountNo,
          clientId: this.close.clientId,
          clientBindId: this.close.clientBindId,
          description: this.close.description,
          buySell: this.close.buy.buySell,
          orderPrice: this.close.buy.orderPrice,
          orderVolume: this.close.buy.orderVolume,
          offsetFlag: this.close.buy.offsetFlag,
          hedgeFlag: this.close.buy.hedgeFlag,
          tradeToken: token
        }
        let sellData = {
          exchange: this.close.exchange,
          underlying: this.close.underlying,
          subAccountNo: this.close.subAccountNo,
          clientId: this.close.clientId,
          clientBindId: this.close.clientBindId,
          description: this.close.description,
          buySell: this.close.sell.buySell,
          orderPrice: this.close.sell.orderPrice,
          orderVolume: this.close.sell.orderVolume,
          offsetFlag: this.close.sell.offsetFlag,
          hedgeFlag: this.close.sell.hedgeFlag,
          tradeToken: token
        }
        if(buyData.orderVolume && sellData.orderVolume) {
          this.axios.post("client/forward/forwardorderlog/requestCloseBatch.do", this.qs.stringify(buyData)).then(result => {
            if(result == 'token' ) {
              this.closeData = this.close
              let obj = {
                id: this.id,
                type: 'AllClose'
              }
              this.dialogVisible = false
              bus.$emit("checkPass", obj)
            }
            if(result.data.success) {
              window.sessionStorage.setItem('token', result.data.FORWARD_TRADE_TOKEN)
              let sellData = {
                exchange: this.close.exchange,
                underlying: this.close.underlying,
                subAccountNo: this.close.subAccountNo,
                clientId: this.close.clientId,
                clientBindId: this.close.clientBindId,
                description: this.close.description,
                buySell: this.close.sell.buySell,
                orderPrice: this.close.sell.orderPrice,
                orderVolume: this.close.sell.orderVolume,
                offsetFlag: this.close.sell.offsetFlag,
                hedgeFlag: this.close.sell.hedgeFlag,
                tradeToken: result.data.FORWARD_TRADE_TOKEN
              }
              this.axios.post("client/forward/forwardorderlog/requestCloseBatch.do", this.qs.stringify(sellData)).then(result => {
                if(result.data.success) {
                  window.sessionStorage.setItem('token', result.data.FORWARD_TRADE_TOKEN)
                  this.$message({
                    type:"success",
                    message:"平仓请求发送成功",
                    showClose: true
                  })
                  this.dialogVisible = false
                  this.handleClose()
                  this.anewGet()
                }
              })
            }
          })
        }
        if(sellData.orderVolume && !buyData.orderVolume) {
          this.axios.post("client/forward/forwardorderlog/requestCloseBatch.do", this.qs.stringify(sellData)).then(result => {
            if(result == 'token' ) {
              this.closeData = this.close
              let obj = {
                id: this.id,
                type: 'AllClose'
              }
              this.dialogVisible = false
              bus.$emit("checkPass", obj)
            }
            if(result.data.success) {
              window.sessionStorage.setItem('token', result.data.FORWARD_TRADE_TOKEN)
              this.$message({
                type:"success",
                message:"平仓请求发送成功",
                showClose: true
              })
              this.dialogVisible = false
              this.handleClose()
              this.anewGet()
            }
          })
        }
        if(buyData.orderVolume && !sellData.orderVolume) {
          this.axios.post("client/forward/forwardorderlog/requestCloseBatch.do", this.qs.stringify(buyData)).then(result => {
            if(result == 'token' ) {
              this.closeData = this.close
              let obj = {
                id: this.id,
                type: 'AllClose'
              }
              this.dialogVisible = false
              bus.$emit("checkPass", obj)
            }
            if(result.data.success) {
              window.sessionStorage.setItem('token', result.data.FORWARD_TRADE_TOKEN)
              this.$message({
                type:"success",
                message:"平仓请求发送成功",
                showClose: true
              })
              this.dialogVisible = false
              this.handleClose()
              this.anewGet()
            }
          })
        }
        if(!buyData.orderVolume && !sellData.orderVolume) {
          this.$message({
            type:"warning",
            message:"两个平仓数量不能同时为0",
            showClose: true
          })
        }
      },
      handleClose() {
        this.dialogVisible = false
        this.close = {    
          exchange: '',
          underlying: '',
          subAccountNo: '',
          clientId: '',
          clientBindId: '',
          description: '',
          buy: {
            buySell: 'B',
            orderPrice: '',
            orderVolume: '',
            copuNum: 0,
            offsetFlag: '',
            hedgeFlag: '',
          },
          sell: {
            buySell: 'S',
            orderPrice: '',
            orderVolume: '',
            copuNum: 0,
            offsetFlag: '',
            hedgeFlag: '',
          },
        }
      },
      oneHandleClose() {
        this.dialogUnilateral = false
        this.oneClose = {
          exchange: '',
          underlying: '',
          subAccountNo: '',
          clientId: '',
          clientBindId: '',
          description: '',
          buySell: '',
          orderPrice: '',
          orderVolume: '',
          copuNum: 0,
          offsetFlag: '',
          hedgeFlag: '',
        }
      },
      BuyChangeOffsetFlag(val) {
        if(val == 3 && this.row.exchange == "SHFE" || val == 3 && this.row.exchange == "INE") {
          this.close.buy.orderVolume = this.row.buyTodayDayRemainCloseVolume
          this.close.buy.copyNum = this.row.buyTodayDayRemainCloseVolume
        } else if( this.row.exchange == "SHFE" || this.row.exchange == "INE") {
          this.close.buy.orderVolume = this.row.buyHistoryDayRemainCloseVolume  
          this.close.buy.copyNum = this.row.buyHistoryDayRemainCloseVolume
        }
      },
      SellChangeOffsetFlag(val) {
        if(val == 3 && this.row.exchange == "SHFE" || val == 3 && this.row.exchange == "INE") {
          this.close.sell.orderVolume = this.row.sellTodayDayRemainCloseVolume
          this.close.sell.copyNum = this.row.sellTodayDayRemainCloseVolume
        } else if( this.row.exchange == "SHFE" || this.row.exchange == "INE") {
          this.close.sell.orderVolume = this.row.sellHistoryDayRemainCloseVolume
          this.close.sell.copyNum = this.row.sellHistoryDayRemainCloseVolume
        }
        
      },
      // 提示文字是否显示
      isShow(copyNum, offsetFlag, exchange) {
        if(!copyNum && offsetFlag == '1') {
          if(exchange == 'SHFE' || exchange == 'INE') {
            return '历史仓可平仓量为0,如需平今仓可自行切换'
          } else {
            return ''
          }
        } else {
          return ''
        }
      },

      closeDis(row) {
        if(row.buyHistoryDayRemainCloseVolume + row.buyTodayDayRemainCloseVolume == 0 && row.sellHistoryDayRemainCloseVolume + row.sellTodayDayRemainCloseVolume == 0) {
          return true
        } else {
          return false
        }
      },

      // 改变显示的字段
      getShowFields() {   //获取显示的字段
        this.isLoad = false
        axios.post("client/queryClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id, 
          businessType: 3,
        })).then(result => {
          if(result.data.success) {
            let datas = JSON.parse(result.data.fieldInformation)
            if(datas && datas.length) {
              this.showFields = datas
              this.isLoad = true
            } else {
              this.showFields = this.allFields
              this.isLoad = true
            }
          }
        }).catch(err => {
          this.isLoad = true
        })
      },
      enter() {
        let arr = []
        this.showValue.forEach(list => {
          this.allFields.forEach(item => {
            if(list === item.key) {
              arr.push(item)
            }
          })
        })

        axios.post("client/addClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id,
          businessType: 3,
          fieldInformation: JSON.stringify(arr)
        })).then(result => {
          if(result.data.success) {
            this.$message.success("设置成功")
            this.getShowFields()
          }
        })

        // let datas = this.clone(this.tableFields)
        // datas.entrustHis = arr
        // bus.$emit("changeFields", datas)
        this.beforeClose()
      },

      beforeClose() {
        this.showValue = []
        this.dialogShowFields = false
      },
      leftChange(arr) {
        this.showValue = [...this.showValue, ...arr]
      },
      rightChange(arr) {
        arr.forEach(list => {
          for(let i = 0; i < this.showValue.length; i++) {
            if(list === this.showValue[i]) {
              this.showValue.splice(i, 1)
            }
          }
        })
      },

      openDialog() {
        let arr = []
        this.showFields.forEach(item => {
          arr.push(item.key)
        })
         this.showValue = arr
        this.dialogShowFields = true
      },

      anewGet() {
        setTimeout(() => {
          bus.$emit("anewGet")   //刷新页面数据
        }, 1000)
      },
      

      // 处理表单数据
      changeTime(val) {
        return this.timeFormat(new Date(val), "-")
      },
      direction(open, buy) {
        let o = open == "O" ? "开" : "平"
        let b = buy == "B" ? "买" : "卖"
        return b + o
      },
      buyMab(obj){
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)
        let price = Number(obj.buyContractValue).toFixed(this.precision) * a
        let num = obj.buyContractVolume
        let mab = price * num / a
        // return mab
        return Number(obj.buyContractValue).toFixed(this.precision)
      },
      sellMab(obj){
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)
        let price = Number(obj.sellContractValue).toFixed(this.precision) * a
        let num = obj.sellContractVolume
        let mab = price * num / a
        // return mab
        return Number(obj.sellContractValue).toFixed(this.precision)
      },
      // 买持仓盈亏（浮）= 持仓手数 * 最新价 * 合约乘数 - 买期初成交价持仓市值(逐笔)
      // 卖持仓盈亏（浮）= 买期初成交价持仓市值(逐笔) - 持仓手数 * 最新价 * 合约乘数
      float(obj){
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)

        let price = 0   //实时价格
        let futuresMultiple = obj.futuresMultiple   //合约乘数

        let buyNum = obj.buyContractVolume    //买持仓数量
        let selleNum = obj.sellContractVolume   //卖持仓数量
        let buyPosition = Number(obj.buyOriginalPriceContractValue).toFixed(this.precision) * a     //买期初成交价持仓市值(逐笔)
        let sellePosition = Number(obj.sellOriginalPriceContractValue).toFixed(this.precision) * a    //卖期初成交价持仓市值(逐笔)
        // 通过标的和子账获取最新价格
        this.socketData.forEach(item => {
          if(item.market == obj.exchange && item.code == obj.underlying && item.subAccountNo == obj.subAccountNo) {
            price = Number(item.price) * a
          }
        })
        let buy = Math.round(price * futuresMultiple * buyNum - buyPosition)
        let sell = Math.round(sellePosition - price * futuresMultiple * selleNum)
        let float = (buy + sell) / a
        return float
      },
      // 买持仓盈亏（盯市）= 最新价 * 持仓数量 * 合约乘数 - 买持仓市值(盯市)
      // 卖持仓盈亏（盯市）= 买持仓市值(盯市) - 最新价 * 持仓数量 * 合约乘数
      floatF(obj){
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)     //用于将小数转化成整数进行计算，最后再转化回来

        let price = 0   //实时价格
        let futuresMultiple = obj.futuresMultiple   //合约乘数

        let buyNum = obj.buyContractVolume    //买持仓数量
        let sellNum = obj.sellContractVolume   //卖持仓数量

        let buyContractValue = obj.buyContractValue    //买持仓市值(盯市)
        let sellContractValue = obj.sellContractValue   //卖持仓市值(盯市)
        // 通过标的和子账获取最新价格
        this.socketData.forEach(item => {
          if(item.market == obj.exchange && item.code == obj.underlying && item.subAccountNo == obj.subAccountNo) {
            price = Number(item.price) * a
          }
        })
        let buy = price * buyNum * futuresMultiple - buyContractValue
        let sell = sellContractValue - price * sellNum * futuresMultiple
        let float = (buy + sell) / a
        return float
        
      },
      // 持仓成本
      cost(obj){
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)
        let AveragePrice = 0
        let buy = obj.buyContractVolume
        let sell = obj.sellContractVolume
        let num = Math.abs(buy - sell)
        if(buy > sell) {
          AveragePrice = Number(obj.buyAveragePrice).toFixed(this.precision) * a
        } else {
          AveragePrice = Number(obj.sellAveragePrice).toFixed(this.precision) * a
        }

        let cost = AveragePrice * num / a
        return cost
      },
      // 平仓盈亏(盯)
      closeOutLoss(obj) {
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)
        let buy = Number(obj.buyTodayCloseProfit).toFixed(this.precision) * a
        let sell = Number(obj.sellTodayCloseProfit).toFixed(this.precision) * a

        let price = (buy + sell) / a
        return price
      },
      // 逐笔
      closeOutLossZ(obj) {
        let a = '1'
        for(let i=0;i<this.precision;i++) {
          a+=0
        }
        a = Number(a)
        let buy = Number(obj.buyOriginalPriceTodayCloseProfit).toFixed(this.precision) * a
        let sell = Number(obj.sellOriginalPriceTodayCloseProfit).toFixed(this.precision) * a

        let price = (buy + sell) / a
        return price
      },
      // 净头寸持仓
      net(obj){
        let buy = obj.buyContractVolume
        let sell = obj.sellContractVolume
        let num = Math.abs(buy - sell)
        return num
      },
      changeSubNo(obj) {
        let arr = this.subNos.filter((item) => {
          return item.subAccountNo == obj.subAccountNo
        })
        return arr[0].subAccountBusinessName
      },
      round(val) {
        return Number(val).toFixed(2)
      },
    },
    destroyed() {

    },
    watch: {
      PositionData(newValue, oldValue) {
        if (newValue.length > 0) {
          this.daochudisabled = false
          bus.$emit("changeCCFlag", false)
        } else {
          this.daochudisabled = true
          bus.$emit("changeCCFlag", true)
        }
      },

      $route: {
        handler(to, from) {
          this.dis = to.query.dis
          let user = to.query.user
          let id = to.query.id
          let sub = to.query.sub
          if (to.path == '/forwardType' && user && id && sub) {
            this.sub = to.query.sub
            this.id = to.query.id
            this.user = to.query.user
            this.PositionChange()
            this.showFields = this.allFields
            this.getShowFields()
          } else {
            this.PositionData = []
          }
        },
        immediate: true
        
      }
    },
    props:['subNos', 'socketData']
  }

</script>

<style scoped>
.el-row {
  padding: 5px;
}
.el-row>.el-col {
  display: flex;
  align-items: center;
}
.close_hint {
  color: red;
  text-align: center;
  padding: 10px 0;
}

.cut-off {
  position: absolute;
  top: 160px;
  left: 50%;
  height: 230px;
  width: 1px;
  background: #000;
}

.el-table__body-wrapper,.is-scrolling-left {
  height: 180px;
}

</style>
